import api from "@/service/api";
export default {
  namespaced: true,
  state: () => ({
    queryPairData: [],
  }),
  mutations: {
    SET_QUERY_PAIR_DATA(state, opt) {
      state.queryPairData = opt;
    },
  },
  actions: {
    async getQueryPairData({ commit }) {
      const queryPairData = await api["queryPair"]({});
      commit("SET_QUERY_PAIR_DATA", queryPairData);
      return queryPairData;
    },
  },
  getters: {},
};
